export const floatingStateListReserve = [
  {
    'key': 'R',
    'value': 'R',
    'text': 'RESERVA',
  },
];

export const floatingStateListSolNac = [
  {
    'key': 'S',
    'value': 'S',
    'text': 'SOLICITUD DE NACIONALIZACIÓN',
  },
];
